import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { LayoutService } from '../../layouts/layout.service';
import { StatCardComponent, StatCardData } from '../../shared/components/stat-card/stat-card';
import { RecentIncidentsComponent } from '../../shared/components/recent-incidents/recent-incidents';
import { StageDonutChartComponent } from '../../shared/components/stage-donut-chart/stage-donut-chart';
import { StageDataPoint } from '../../shared/models/dashboard.models';
import { User } from '../../shared/models/user.models';
import { IncidentListItem as Incident } from '../../shared/models/incident.models';
import { DashboardService } from '../../core/services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  imports: [
    // StatCardComponent,
    RecentIncidentsComponent,
    // StageDonutChartComponent
  ],
  templateUrl: './dashboard.html',
})
export class DashboardComponent implements OnInit {
  protected authService = inject(AuthService);
  private layout = inject(LayoutService);

  protected users = signal<User[]>([]);
  private dashboardService = inject(DashboardService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  protected recentIncidents = signal<Incident[]>([]);
  protected recentLoading = signal(true);

  protected stats: StatCardData[] = [
    {
      value: '42',
      label: 'Active Investigations',
      iconUrl: '/icons/magnifying-glass-icon.svg',
      variant: 'blue',
    },
    { value: '87', label: 'Incident Volume', iconUrl: '/icons/info-icon.svg', variant: 'red' },
    {
      value: '3.2d',
      subValue: 'AVG',
      label: 'Incident Resolution Time',
      iconUrl: '/icons/clock-icon.svg',
      variant: '',
    },
    {
      value: '1.5d',
      subValue: 'AVG',
      label: 'Investigation Resolution Time',
      iconUrl: '/icons/clock-icon.svg',
      variant: '',
    },
  ];

  protected stageData: StageDataPoint[] = [
    { label: 'Creation', value: 45, color: '#4f86f7' },
    { label: 'Incident Detail', value: 23, color: '#a855f7' },
    { label: 'Review', value: 17, color: '#f59e0b' },
    { label: 'Follow Up', value: 9, color: '#f472b6' },
    { label: 'Compliance & PQ', value: 6, color: '#10b981' },
  ];

  ngOnInit(): void {
    this.layout.set({
      title: 'Dashboard',
      breadcrumb: 'Monitor and manage JCCA incident reports.',
      showBackButton: false,
      switchPlaces: false,
      darkHeader: true,
    });

    this.loadRecentIncidents();
  }

  protected onViewAll(): void {
    this.router.navigate(['/incidents']);
  }

  private loadRecentIncidents(): void {
    this.dashboardService
      .getRecentIncidents(10)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.recentIncidents.set(res.incidents ?? []);
          this.recentLoading.set(false);
        },
        error: () => this.recentLoading.set(false),
      });
  }
}
